module.exports = __webpack_public_path__ + "static/img/sheduling.0236638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sheduling.png
// module id = xU7L
// module chunks = 0